// extracted by mini-css-extract-plugin
export default {"root":"SkillCommandSection_root__j71Rq","tooltip":"SkillCommandSection_tooltip__l60kx","tooltipContainer":"SkillCommandSection_tooltipContainer__wtWRg"};